"use strict";
(($, win, doc) => {    // JQ ES6 sw Pack 21
  
  const $win = $(win),
    $doc = $(doc),
    $html = $('html'),
    $body = $('body'),
    swns = {
      goToTop: function () {
        let $goToTop = $("#goto-top");
        $goToTop.hide();
        $.timeout = function (time) {
          return $.Deferred(function (dfd) {
            return setTimeout(dfd.resolve, time);
          }).promise();
        };
        $win.on("scroll", function () {
          if ($(this).scrollTop() > 789) {
            $goToTop.stop(true, true).fadeIn();
          } else {
            $goToTop.fadeOut();
          }
        });
        $goToTop.on("click", function (e) {
          e.preventDefault();
          $("body,html").animate({scrollTop: 0}, 200);
        });
      }
  }; // swns{}
  
  /* plugin Type BlockLink */
  $.fn.blocklinkAssy = function () { // bind under this
    $(this).on("click", function (e) {
      e.preventDefault();
      win.open($(this).find("a").attr("href"), $(this).find("a").attr("target") || "_self");
    }).css({cursor: "pointer"});
  };
  
  /*each popup(ChildList) */
  const eachPopUpList = function(popFrom_UL_class) {
    let eachTimeout, target;
    eachTimeout = [];
    target = $(popFrom_UL_class);
    return target.each(function(i) {
      let $this, childID;
      $this = $(this);
      childID = $this.children(".popup").attr("id");
      return $this.parent().hover((function() {
        let j;
        target.hide();
        j = 0;
        while (j < eachTimeout.length) {
          clearTimeout(eachTimeout[j]);
          j++;
        }
        return $this.show();
      }), (function() {
        if (childID === "pop0") {

        } else {
          return eachTimeout[i] = setTimeout((function() {
            return $this.hide();
          }), 369);
        }
      }));
    });
  };
  
  // add current class for nav
  const navCurrentAdd = ()=> {
    let filename = $(".current-control").attr("id");
    //let url = win.location.href.split("/");
    //url = url[url.length -1].split(".html")[0];
    $("#SideNavBase, .drawer-menu").find("> li").each(function(i, val) {
      $(this).removeClass("current");
      let nav_id = $(this).attr("id");
      nav_id = nav_id.replace(/nav-/g,'');
      if (nav_id === filename) { $(this).addClass("current"); }
    })
  };
  
  const checkMediaQuery = ()=> {
    // https://zenn.dev/yuki0410/articles/878f4afbff6668d4e28a-2
    // window.matchMedia をちゃんと使った方法
    const mediaQueryList = window.matchMedia("(max-width:767px)");
    /**
     * イベントリスナー
     */
    const listener = (event) => {
      if (event.matches) {
        console.log('768px未満');
      } else {
        console.log('768px以上');
      }
    };
    mediaQueryList.addEventListener("change", listener);
    listener(mediaQueryList);
  };
  
  const modalControl = ()=> {
    $('.js-modal-open').each(function () {
      $(this).on('click', function () {
        let target = $(this).data('target');
        let modal = document.getElementById(target);
        $(modal).fadeIn(300);
        return false;
      });
    });
    $('.js-modal-close').on('click', function () {
      $('.js-modal').fadeOut(300);
      return false;
    });
  };
  
  const animateElem = ()=> {
    /**
     * js_contAnimation
     */
    if (($(".contentsList").length)) {
      setTimeout(function () {
        $('.contentsList_item').each(function (i) {
          setTimeout(function () {
            $(".contentsList_item").eq(i).addClass("active");
          }, 99 * i);
        });
      }, 77);
    }
  };
  
  // do it DRF
  $(() => {
    /*UI / UA */
    $("#container").find("h2,h3,h4,h5").each(function () {
      return $(this).wrapInner("<span class='add-span' />");
    });
    
    // sw classic UI's
    swns.goToTop();
    $('.drawer').drawer();
    $(".hNavi").blocklinkAssy();
    // const's
    //checkMediaQuery();
    //navCurrentAdd();
    modalControl();
  
    /* SideNav */
    // clone SideNavBase -> SideNavClone
    //$("#SideNavBase > li").clone().appendTo("#SideNavClone ul");
    // add for WP menu-topmenu -> SideNavClone
    //$("#menu-footer_menu > li").clone().appendTo("#SideNavClone ul");
    // todo popupTarget || clickTarget
    eachPopUpList("ul#menu-footer_menu > li > ul");
  
    /**
     * sitemap id #post-31
     */
    //$("#post-31 #menu-sitemap li.menu-item-48").insertBefore("#post-31 #menu-sitemap li.menu-item-53");
    
  
    /**
     * smooth scr
     * todo assy.jsかこっちかで。
     */
    $('a[href^="#"]').on("click",function(){
      const adjust = -210;
      const speed = 321;
      let href= $(this).attr("href");
      let target = $(href === "#" || href === "" ? 'html' : href);
      let position = target.offset().top + adjust;
      $('body,html').animate({scrollTop:position}, speed, 'easeOutCubic');
      return false;
    });
    
    
    /*// SideNavClone +++ SPハンバーガーでクリック開くかどうか。
    $("nav#SideNavClone > ul > li.clickTarget").on("click", function (e) {
      $(this).siblings().removeClass("current");
      $(this).siblings().find("ul.clickChild").removeClass("show");
      $(this).toggleClass("current");
      $(this).find("ul.clickChild").toggleClass("show");
      e.stopPropagation();  // 親への伝播を止める
    });
    // SideNavBase +++ PCsubメニューopenでクリックかホバーか
    $("ul#SideNavBase > li.clickTarget").on("click", function (e) {
      $(this).siblings().removeClass("hover");
      $(this).addClass("hover");
      $(this).parent().parent().find("ul.clickChild").removeClass("show");
      $(this).find("ul.clickChild").addClass("show");
      $("#re-wrapper").on("click", function (e) {
        $("ul.clickChild").removeClass("show");
        $("ul#SideNavBase > li.clickTarget").removeClass("hover");
      });
      e.stopPropagation();  // 親への伝播を止める
    });
    // SideNavClone + SideNavBase
    $("li.popup").on("click", function (e) {
      $("ul#SideNavBase > li.clickTarget").removeClass("hover");
      $("nav#SideNavClone > ul > li.clickTarget").removeClass("current");
      $("ul.clickChild").removeClass("show");
      e.stopPropagation();  // 親への伝播を止める
    });*/
  
    /**
     * swAnchor アンカー残し版（/#hoge） no return false;
     * @ fixup 外部リンクを避ける修正 & if(target.length) {}
     */
    /*$('a.swAnchor').click(function (e) {
      //e.preventDefault();
      let speed = 543;
      let href = $(this).attr("href");
      if (href.indexOf("#") === 0) {
        let target = $(href === "#" || href === "" ? 'html' : href);
        if (target.length) {
          let position = target.offset().top;
          $("html, body").animate({scrollTop: position - 30}, speed, "easeOutCirc");
          return false; // hide # anchorLink
        }
      }
    });*/
  
    /**
     * sw waypoint .active
     * "waypoint" + animate.css trigger
     * "waypoint animated" data-animate="fadeInLeft"
     * fixme .waypoint.contentsListは cssで .active 配下を加工すれば別個でいけるはず -> .contentsList はページに .waypoint が一回だけの場合(あんま使うと派手になりすぎ)
     * todo https://yokotanojo.co.jp/
     * (中段 .is-fadeInUpList)
     * もしくはCSSのみ（.waypoint併用で）でtranslateでもいける
     */
    $(function () {
      $('.waypoint').waypoint(function (direction) {
        let isAnimate = $(this.element).data('animate') || "";
        let isPlay = $(this.element).data('playagain') || "";
        // todo cssAnim
        let isCssAnim = $(this.element).data('css_animate') || "";
        let activePoint = $(this.element);
        //console.info(activePoint[0], isAnimate);  // #------- sw Log --(´･_･`)
        if (direction === 'down') { //scroll down
          activePoint.addClass('active');
          animateElem();
          if (isAnimate) { activePoint.addClass(`${isAnimate} active`) }
          if (isCssAnim) { activePoint.addClass(`${isCssAnim} is-anime`) }
        } else { //scroll up
          activePoint.removeClass('active');
          if (isPlay === 'playagain') { activePoint.removeClass(`${isAnimate} active`) }
        }
      }, {offset: '95%'}); // Topからの発火位置
  
      $('#bottom-in-view').waypoint(function (direction) {
        let isAnimate = $(this.element).data('animate') || "";
        let activePoint = $(this.element);
        if (direction === 'down') { //scroll down
          activePoint.addClass(`${isAnimate} active`);
        } else { //scroll up
          activePoint.removeClass(`${isAnimate} active`);
        }
      }, {offset: 'bottom-in-view'});
    });
   
    
   /* .es6 サイドナビを固定する場合 (load)
   * fixme JS不具合があるのでこの際 sticky にしましょう 2207 todo add WP is in DRF*/
   // sw sticky add class
   const select = document.querySelector('.headingWrapper'); // stickyの上の要素を取得
   const hasSelector = document.querySelector('.list-fixed');
   const observer = new window.IntersectionObserver((entry) => {
     if (!entry[0].isIntersecting) {
       document.querySelector('.list-fixed').classList.add('add-fixed');
     } else {
       document.querySelector('.list-fixed').classList.remove('add-fixed');
     }
   });
   //console.info(select, hasSelector);  // #------- sw Log --(´･_･`)
   if (hasSelector) { observer.observe(select) };
   
    $(function () {
  
      var setElm = $('.loopSlider'),
        slideSpeed = 123456;
      setElm.each(function () {
        var self = $(this),
          selfWidth = self.innerWidth(),
          findUl = self.find('ul'),
          findLi = findUl.find('li'),
          listWidth = findLi.outerWidth(),
          listCount = findLi.length,
          loopWidth = listWidth * listCount;
  
        findUl.wrapAll('<div class="loopSliderWrap" />');
        var selfWrap = self.find('.loopSliderWrap');
  
        if (loopWidth > selfWidth) {
          findUl.css({width: loopWidth}).clone().appendTo(selfWrap);
          selfWrap.css({width: loopWidth * 2});
          function loopMove() {
            selfWrap.animate({left: '-' + (loopWidth) + 'px'}, slideSpeed * listCount, 'linear', function () {
              selfWrap.css({left: '0'});
              loopMove();
            });
          };
          loopMove();
  
          setElm.hover(function () {
            selfWrap.pause();
          }, function () {
            selfWrap.resume();
          });
        }
      });
    });

  }); // DRF }
  
 
  
  /* =========================================================
  jquery.rollover.js / ver.1.1
  Copyright (c) 2015 CoolWebWindow
  This code is released under the MIT License
  https://osdn.jp/projects/opensource/wiki/licenses%2FMIT_license
  =========================================================*/
  $(function ($) {
    $.fn.rollover = function () {
      return this.each(function () {
        // 画像名を取得
        let src = $(this).attr('src');
        //すでに画像名に「_on.」が付いていた場合、ロールオーバー処理をしない
        if (src.match('_on.')) return;
        // ロールオーバー用の画像名を取得（_onを付加）
        let src_on = src.replace(/^(.+)(\.[a-z]+)$/, "$1_on$2");
        // 画像のプリロード（先読み込み）
        $('<img>').attr('src', src_on);
        // スマホ対応
        let onMouseover = ('ontouchstart' in document) ? 'touchstart' : 'mouseenter';
        let onMouseout = ('ontouchstart' in document) ? 'touchend' : 'mouseleave';
        // ロールオーバー処理
        $(this).on(onMouseover, function () {
          $(this).attr('src', src_on);
        });
        $(this).on(onMouseout, function () {
          $(this).attr('src', src);
        });
      });
    };
  });
  $(document).ready(function ($) {
    $('.ROV a img').rollover();
  });
  
})(jQuery, window, document);

